
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import PanchangLinks from '../../../components/PanchangLinks/PanchangLinks';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Naksatra.scss';
import { Link } from 'react-router-dom';

const nakshatras = [
  //{ id: 1, name: 'Abhijit Nakshatra', img: '', path: ''},
  { id: 1, name: 'Birthstar Calculator', img: '', path: '/jyotish/birthstar' },
  { id: 2, name: 'Name Initials', img: '',path: '/jyotish/name-initials' },

];

const Naksatra = () => {
  return (
      <div className="nakshatra-container">
    <InnerNav />
    <div className="nakshatra-content">
      <Zodiac />
      
      <div className="nakshatra-header">
        <h4>Tara</h4>
      </div>

      <div className="nakshatra-grid">
        {nakshatras.map((nakshatra) => (
          <Link to={nakshatra.path} key={nakshatra.id} className="nakshatra-card">
            <img
              src={nakshatra.img || 'https://media.istockphoto.com/id/809971888/photo/night-sky-landscape.jpg?s=612x612&w=0&k=20&c=ku3RWu4DQ8ErN-KbT1Act72LMocTwSAAm3UDkLiako0='}
              alt={nakshatra.name}
            />
            <p>{nakshatra.name}</p>
          </Link>
        ))}
      </div>

      <PanchangLinks/>
    </div>
    <Footer />
  </div>

  );
};

export default Naksatra;
